export default {
  presets: {
    light: {
      primary: '#FEBF01',
      secondary: '#18181b',
      backgroundPrimary: '#F4F6F8',
      backgroundSecondary: '#FFFFFF',
      backgroundCardPrimary: '#FFFFFF',
      backgroundCardSecondary: '#FFFBEB',
      success: '#10B981',
      info: '#0284C7',
      danger: '#EF4444',
      warning: '#FEBF01',
      textPrimary: '#111827',
      textSecondary: '#6B7280',
    },
    dark: {
      primary: '#FEBF01',
      secondary: '#94A3B8',
      backgroundPrimary: '#0F0F12',
      backgroundSecondary: '#18181B',
      backgroundCardPrimary: '#1C1C21',
      backgroundCardSecondary: '#23232A',
      success: '#10B981',
      info: '#38BDF8',
      danger: '#EF4444',
      warning: '#FEBF01',
      textPrimary: '#F4F4F5',
      textSecondary: '#A1A1AA',
    },
  },
}
